module.exports = __webpack_public_path__ + "column.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/column.svg?color1=%23333333&color2=
// module id = 2190
// module chunks = 67